// if document is changed then this function will be called to update the cart drawer 
function formatMoney(cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

const cartDrawer = document.querySelector('#cart-drawer');
const cartDrawerClose = document.querySelectorAll('#close-cart');
var loaderSkeleton = document.querySelector('.loader__skeleton');
const body = document.body;

function setLoaderSkeletonVisible(isVisible) {
  if (loaderSkeleton) {
    loaderSkeleton.style.display = isVisible ? 'block' : 'none';
  }
}

function pushCartDrawerResult(ok, extra) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(Object.assign({
    event: 'fwe_cart_drawer_result',
    cart_drawer_ok: ok
  }, extra || {}));
}

// This function is used to fetch the cart drawer data from a end point i have created in the template with no layout containing the liquid code to append. 
async function refreshCartDrawer() {
  setLoaderSkeletonVisible(true);

  try {
    const response = await fetch('/?view=cart-drawer');
    const cartData = await response.text();

    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = cartData;

    // Replace the cart drawer body content
    const cartDrawerBody = document.querySelector('.cart-drawer__body');
    if (!cartDrawerBody) {
      pushCartDrawerResult(false, {
        cart_drawer_error_message: 'missing_cart_drawer_body'
      });
      return false;
    }
    cartDrawerBody.innerHTML = '';

    // Append everything except <script> tags
    Array.from(tempDiv.childNodes).forEach(node => {
      if (node.tagName !== 'SCRIPT') {
        cartDrawerBody.appendChild(node.cloneNode(true));
      }
    });

    // Extract and execute script tags manually
    const scriptTags = tempDiv.querySelectorAll('script');
    scriptTags.forEach(oldScript => {
      const newScript = document.createElement('script');
      if (oldScript.src) {
        // If it's an external script
        newScript.src = oldScript.src;
      } else {
        // If it's inline script
        newScript.textContent = oldScript.textContent;
      }
      document.body.appendChild(newScript); // or cartDrawerBody.appendChild if scoped
    });

    setLoaderSkeletonVisible(false);

    const elementsToRemove = document.querySelectorAll('[data-rebuy-id="77545"]');
    elementsToRemove.forEach((element) => element.remove());

    const newDiv = document.createElement('div');
    newDiv.dataset.rebuyId = '77545';

    const cartContainers = document.querySelectorAll('.cart-drawer-upsell__container');
    if (!cartContainers.length) {
      cartShippingThreshold();
      pushCartDrawerResult(true, {
        cart_drawer_refresh: 'no_upsell_container'
      });
      return true;
    }

    const lastCartContainer = cartContainers[cartContainers.length - 1];
    lastCartContainer.appendChild(newDiv);

    if (window.Rebuy) {
      Rebuy.init();
    }

    cartShippingThreshold();
    pushCartDrawerResult(true, {
      cart_drawer_refresh: 'ok'
    });
    return true;
  } catch (error) {
    setLoaderSkeletonVisible(false);
    pushCartDrawerResult(false, {
      cart_drawer_error_message: error && error.message ? error.message : 'cart_drawer_refresh_error'
    });
    console.error('Error refreshing cart drawer:', error);
    return false;
  }
}

document.addEventListener("rebuy:cart.change", function() { refreshCartDrawer(Rebuy.Cart.cart); });

async function toggleCartDrawer(isOpen) {
  const cartDrawer = document.querySelector('.cart-drawer');
  const cartDrawerOverlay = document.querySelector('.cart-drawer-overlay');
  if (!cartDrawer || !cartDrawerOverlay) {
    pushCartDrawerResult(false, {
      cart_drawer_error_message: 'missing_cart_drawer_shell'
    });
    return false;
  }
 
  if (isOpen) {
   
    setTimeout(async () => {
      await refreshCartDrawer();
      cartDrawer.style.transform = 'translateX(0)';
      cartDrawerOverlay.style.display = 'block';
      body.classList.add('cart-drawer-open');
      cartShippingThreshold();
      pushCartDrawerResult(true, {
        cart_drawer_open: true
      });
    }, 1000);
    return true;
  } else {
    cartDrawer.style.transform = 'translateX(100%)';
    cartDrawerOverlay.style.display = 'none';
    body.classList.remove('cart-drawer-open');
    return true;
  }
}


const toggleCartDrawerButtons = document.querySelectorAll('[toggle-cart-drawer]');
toggleCartDrawerButtons.forEach((button) => {
  button.addEventListener('click', () => toggleCartDrawer(true));
});

const elementsToTriggerCartDrawer = '.addToCart, .button--pdp, .add-to-cart, .btn--submit, .quickAdd, .addtc-sticky-btn';
const elementsToTrigger = document.querySelectorAll(elementsToTriggerCartDrawer);
elementsToTrigger.forEach((element) => {
  element.addEventListener('click', () => {
      if (element.closest('.shopify-product-form')) {
        return;
      }
      refreshCartDrawer();
      cartShippingThreshold();
      toggleCartDrawer(true);
  });
});

/// Function for close the cart drawer 
cartDrawerClose.forEach(function (button) {
  button.addEventListener('click', function () {
    const cartDrawerOverlay = document.querySelector('.cart-drawer-overlay');
    if (cartDrawer) cartDrawer.style.transform = 'translateX(100%)';
    if (cartDrawerOverlay) cartDrawerOverlay.style.display = 'none';
    body.classList.remove('cart-drawer-open');
  });
});

// Close cart drawer when clicking outside the drawer (on body when cart-drawer-open class is present)
body.addEventListener('click', function (e) {
  // Only close if cart drawer is open and click is not on the cart drawer itself
  if (body.classList.contains('cart-drawer-open') && 
      !e.target.closest('.cart-drawer') && 
      !e.target.closest('[toggle-cart-drawer]') &&
      !e.target.closest('.addToCart, .button--pdp, .add-to-cart, .btn--submit, .quickAdd, .addtc-sticky-btn')) {
    const cartDrawerOverlay = document.querySelector('.cart-drawer-overlay');
    if (cartDrawer) cartDrawer.style.transform = 'translateX(100%)';
    if (cartDrawerOverlay) cartDrawerOverlay.style.display = 'none';
    body.classList.remove('cart-drawer-open');
  }
});

/// Function on click to add upsell product to cart and call the addUpsellToCart function
const cartDrawerBody = document.querySelector('.cart-drawer__body');
if (cartDrawerBody) {
  cartDrawerBody.addEventListener('click', function (e) {
    if (e.target.id === 'upsell-add') {
      const upsellBtn = e.target;
      const upsellId = upsellBtn.getAttribute('upsell-id');
      addUpsellToCart(upsellBtn, upsellId);
    }
  });
}

// This function is for updating the quantity for each item in the cart drawer, and it is then calling the updateQunaity function

if (cartDrawerBody) {
cartDrawerBody.addEventListener('click', function (e) {
  if (e.target.classList.contains('cart-drawer-quantity__minus')) {
    const cartDrawerQuantityVal = e.target.parentElement.querySelector('.cart-drawer__item-quantity__val');
    const itemId = cartDrawerQuantityVal.getAttribute('data-item-id');
    const quantity = parseInt(cartDrawerQuantityVal.value, 10) - 1;
    if (quantity >= 1) {
      updateCart(itemId, quantity, 'updateItemQty');
    }
  }
  if (e.target.classList.contains('cart-drawer-quantity__plus')) {
    const cartDrawerQuantityVal = e.target.parentElement.querySelector('.cart-drawer__item-quantity__val');
    const itemId = cartDrawerQuantityVal.getAttribute('data-item-id');
    const quantity = parseInt(cartDrawerQuantityVal.value, 10) + 1;
    updateCart(itemId, quantity, 'updateItemQty');
  }
  if (e.target.classList.contains('cart-drawer__item-delete')) {
    const itemId = e.target.getAttribute('data-item-id');
    updateCart(itemId, 0,'removeItem' )
  }

  if (e.target.classList.contains('smart-cart-drawer-upsell-product-add')) {
    e.preventDefault();
    const upsellBtn = e.target;
    const upsellId = upsellBtn.getAttribute('data-varaint');
    const quantity = 1;
    addToCart(upsellId, quantity);
  }
});
}

// this function handles the update item quanity as well as the remove item from the cart as it takes the type as a parameter
async function updateCart(itemId, quantity, type) {
  try {
    // Fetch the current cart
    const res = await fetch('/cart.js'); 
    const cart = await res.json(); 
    const item = cart.items.find((item) => (item.key == itemId));
    if (type === 'updateItemQty' && !item) return;
    // Check if the item is already at the desired quantity for update and return if true
    if (type === 'updateItemQty' && item.quantity === quantity) return;

    // Make a request to update or delete the item in the cart 
    let updatedRes;
    if (type === 'updateItemQty') {
       updatedRes = await fetch('/cart/change.js', {
         method: 'POST',
         headers: {
           'Content-Type': 'application/json'
         },
         body: JSON.stringify({
           id: itemId,
           quantity: quantity
         })
       });
    } else if (type === 'removeItem') {
       updatedRes = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: itemId,
          quantity: quantity
        })
       });
    }
    const updatedCart = await updatedRes.json();
    
    if (type === 'updateItemQty') {

        const updatedItem = updatedCart.items.find((item) => (item.key == itemId));
        if (!updatedItem) return;
        const itemPrice = updatedItem.final_line_price;
        const cartDrawerRoot = document.getElementById('cart-drawer');
        const moneyFormat = cartDrawerRoot ? cartDrawerRoot.getAttribute('data-money-format') : '';
        const cartDrawerSubtotalPrice = document.querySelector('.cart-drawer-subtotal__price');
        const cartDrawerItemPrice = document.querySelector(`[data-item-id="${itemId}"] .cart-drawer__item-price`);
        if (cartDrawerSubtotalPrice) cartDrawerSubtotalPrice.innerHTML = formatMoney(updatedCart.total_price, moneyFormat);
        if (cartDrawerItemPrice) cartDrawerItemPrice.innerHTML = formatMoney(itemPrice, moneyFormat);

          refreshCartDrawer();

    } else if (type === 'removeItem') {
        setLoaderSkeletonVisible(true);
        if (cart.items.length === 0) {
          const cartDrawerOverlay = document.querySelector('.cart-drawer-overlay');
          if (cartDrawer) cartDrawer.style.transform = 'translateX(100%)';
          if (cartDrawerOverlay) cartDrawerOverlay.style.display = 'none';
          body.classList.remove('cart-drawer-open');
          const cartDrawerForm = document.querySelector('#cart-drawer__form');
          if (cartDrawerForm) cartDrawerForm.remove();
          const emptyState = document.createElement('div');
          emptyState.innerHTML = `
            <div class="cart-drawer__empty">
              <p class="cart-drawer__empty-text"> Your Basket is empty </p>
              <span> Add your favorite items to My Cart .</span>
              <a class="cart-drawer__empty-btn" href="/"> Shop Now <a>
            </div>`;
          const emptyTarget = document.querySelector('.cart-drawer .cart-drawer__body');
          if (emptyTarget) emptyTarget.appendChild(emptyState);
        } else {
          const removeItem = document.querySelector('.cart-drawer__item[data-item-id="' + itemId + '"]');
          setLoaderSkeletonVisible(false);
          if (removeItem) removeItem.remove();
          await refreshCartDrawer();
        }
      }
    jQuery.getJSON('/cart.js', function(cart) {
      $("span.cartCount").html(cart.item_count);
        var customerName = $("#cart-data").data("customer-name");
        if (customerName) {
            $("span.cartCount_drawer").html(customerName + "'s Cart <span> "+ cart.item_count +"</span>");
        } else {
            $("span.cartCount_drawer").html("My Cart <span>" + cart.item_count + "</span>");
        }
          });
  } catch (error) {
    console.error('Error updating cart:', error);
  }
  cartShippingThreshold();
}


function getCartAddErrorTarget(sourceRoot) {
  if (sourceRoot && sourceRoot.querySelector) {
    return sourceRoot.querySelector('[data-cart-add-error]');
  }
  return document.querySelector('[data-cart-add-error]');
}

function showCartAddError(sourceRoot, message) {
  const errorTarget = getCartAddErrorTarget(sourceRoot);
  if (errorTarget) {
    errorTarget.textContent = message;
    errorTarget.hidden = false;
    errorTarget.style.display = 'block';
  } else if (message) {
    console.warn(message);
  }
}

function clearCartAddError(sourceRoot) {
  const errorTarget = getCartAddErrorTarget(sourceRoot);
  if (!errorTarget) return;
  errorTarget.textContent = '';
  errorTarget.hidden = true;
  errorTarget.style.display = 'none';
}

function cartAddErrorMessage(responseBody) {
  if (responseBody && responseBody.description) return responseBody.description;
  if (responseBody && responseBody.message) return responseBody.message;
  return 'We could not add this item to cart. Please confirm the size and width are still available.';
}

function pushCartAddResult(ok, id, quantity, extra) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(Object.assign({
    event: 'fwe_cart_add_result',
    cart_add_ok: ok,
    variant_id: id || null,
    quantity: quantity || 1
  }, extra || {}));
}

$('.shopify-product-form').on('submit', function(event) {
  event.preventDefault();
  const formEl = this;
  const selectElement = formEl.querySelector('.original-selector');
  const checkRechargeRadio = formEl.querySelector("#rc-radio2") || document.getElementById("rc-radio2");
  const quantityInput = formEl.querySelector('[name="quantity"]');
  const qtyValue = quantityInput && parseInt(quantityInput.value, 10) > 0 ? parseInt(quantityInput.value, 10) : 1;

  let selectedValue = '';
  let sellingPlanId = '';
  clearCartAddError(formEl);

  if (selectElement) {
    const selectedOption = selectElement.options[selectElement.selectedIndex];
    if (selectedOption) {
      selectedValue = selectedOption.value;
      sellingPlanId = selectedOption.getAttribute('selling-plan') || '';
    }
  } else {
    const variantInput = formEl.querySelector('[name="id"]');
    selectedValue = variantInput ? variantInput.value : '';
  }

  if (!selectedValue) {
    showCartAddError(formEl, 'Please select a size and width before adding to cart.');
    pushCartAddResult(false, null, qtyValue, {
      cart_add_error_message: 'missing_variant'
    });
    return;
  }

  if (!(checkRechargeRadio && checkRechargeRadio.checked)) {
    sellingPlanId = '';
  }

  addToCart(selectedValue, qtyValue, sellingPlanId, formEl);
});



// Add product to cart function 
async function addToCart(id, quantity, sellingPlanAllocationId, sourceForm) {
  const cartQuantity = parseInt(quantity, 10) > 0 ? parseInt(quantity, 10) : 1;
  clearCartAddError(sourceForm);

  if (!id) {
    const missingVariantMessage = 'Please select a size and width before adding to cart.';
    showCartAddError(sourceForm, missingVariantMessage);
    pushCartAddResult(false, null, cartQuantity, {
      cart_add_error_message: 'missing_variant'
    });
    return false;
  }

  const payload = {
    id: id,
    quantity: cartQuantity
  };

  if (sellingPlanAllocationId) {
    payload.selling_plan = sellingPlanAllocationId;
  }

  try{
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    });
    let responseBody = {};
    try {
      responseBody = await res.clone().json();
    } catch (jsonError) {
      responseBody = {};
    }

    if (!res.ok) {
      const message = cartAddErrorMessage(responseBody);
      showCartAddError(sourceForm, message);
      pushCartAddResult(false, id, cartQuantity, {
        cart_add_status: res.status,
        cart_add_error_message: message
      });
      return false;
    }

    pushCartAddResult(true, id, cartQuantity, {
      cart_add_status: res.status
    });

   // IF RESPONSE IS 200 THEN SHOW THE CART DRAWER
    if (res.ok) {
      jQuery.getJSON('/cart.js', function(cart) {
      $("span.cartCount").html("("+cart.item_count+")");
        
    var customerName = $("#cart-data").data("customer-name");
    if (customerName) {
        $("span.cartCount_drawer").html(customerName + "'s Cart <span>(" + cart.item_count + ")</span>");
    } else {
        $("span.cartCount_drawer").html("My Cart <span>(" + cart.item_count + ")</span>");
    }
      });
      toggleCartDrawer(true);
    }
    return true;

  }catch(err){
    const message = err && err.message ? err.message : 'cart_add_fetch_error';
    showCartAddError(sourceForm, 'We could not add this item to cart. Please try again.');
    pushCartAddResult(false, id, cartQuantity, {
      cart_add_status: 0,
      cart_add_error_message: message
    });
    return false;

  }
}
  //get add to cart to work with collection page and its products. 
const tabCollectionContent = document.querySelector('.tab_collection_content');
if (tabCollectionContent) {
  tabCollectionContent.addEventListener('click', function (e) {
      if (e.target.classList.contains('btn--submit')) {
          e.preventDefault();
          const inputValue = e.target.parentElement.querySelector('#varaint-id__input').value;
          const inputQuantity = e.target.parentElement.querySelector('input').value;
          addToCart(inputValue, inputQuantity);
      }
  });
}

const bundleProduct = document.querySelectorAll('.product-bundle-submit');
if (bundleProduct) {
bundleProduct.forEach((product) => {
  product.addEventListener('click', function (e) {
    e.preventDefault();
    const input = e.target.parentElement.querySelector('#varaint-id__input');
    const inputValue = input ? input.value : null;
    const bundleQuantity = e.target.parentElement.querySelector('input').value;
    if (inputValue !== null) {
      addToCart(inputValue, bundleQuantity);
    }
  });
});
}
const quickAddCollection = document.querySelectorAll('.main-collection-quick-add');
if (quickAddCollection) {
  quickAddCollection.forEach((product) => {
    product.addEventListener('click', function (e) {
      if (e.target.classList.contains('quick-search')) {
        // Quick search button clicked, do nothing
        return;
      }
      else if (e.target.classList.contains('btn--submit')) {
        // Other button clicked, prevent default and call addToCart
        e.preventDefault();
        const input = e.target.parentElement.querySelector('#varaint-id__input');
        const inputValue = input ? input.value : null;
        const bundleQuantity = e.target.parentElement.querySelector('input').value;
        if (inputValue !== null) {
          addToCart(inputValue, bundleQuantity);
        }
      }
    });
  });
}
function cartShippingThreshold() {
  jQuery.getJSON('/cart.js', function(cart) {
    $("span.cartCount").html(cart.item_count);
    
    var customerName = $("#cart-data").data("customer-name");
    if (customerName) {
        $("span.cartCount_drawer").html(customerName + "'s Cart <span>(" + cart.item_count + ")</span>");
    } else {
        $("span.cartCount_drawer").html("My Cart <span>(" + cart.item_count + ")</span>");
    }
});
  // Carts subtotal
  var threadval = $(".cart-dawer__container").attr("data-free-shipping");
  var threadcont = $(".cart-dawer__container").attr("data-free-shippingval");
  
  setTimeout(function(){
  $('.cart-template__shipping-threshold-amount[data-free-shipping]').attr('data-free-shipping',threadval);
    $('.cart-template__shipping-threshold-amount[data-free-shipping]').html(threadcont);
  var cartSubtotal = document.querySelector('.carttotal .theme-money')?.textContent;
  if (!cartSubtotal) return;
  cartSubtotal = cartSubtotal.split('$')[1];
  if (!cartSubtotal) return;
  cartSubtotal = cartSubtotal.indexOf(',') ? cartSubtotal.split(',').join('') : cartSubtotal;

  // Shipping Threshold amount
  var shippingThresholdElement = document.querySelector('.cart-template__shipping-threshold-amount[data-free-shipping]');
  if (!shippingThresholdElement) return;
  var shippingThreshold = shippingThresholdElement.getAttribute('data-free-shipping');
  if (!shippingThreshold) return;
  shippingThreshold = shippingThreshold.indexOf(',') ? shippingThreshold.split(',').join('') : shippingThreshold;

  // Amount away from Free Shipping
  var totalAway = shippingThreshold - cartSubtotal;

  // Progress bar width
  var progressBarWidth = ((cartSubtotal / shippingThreshold) * 100).toFixed();
  // We don't want the width to be more than 100%
  progressBarWidth > 100 ? progressBarWidth = 100 : '';
 
  // Progress bar
  var progressBar = document.querySelectorAll('.cart-template__shipping-threshold-bar-progress');
  for (i = 0; i < progressBar.length; i++) {
    progressBar[i].style = 'width: ' + progressBarWidth + '%';
  }

  // Threshold message
  var thresholdMessage = document.querySelectorAll('.cart-template__shipping-threshold-msg');
  var shipping_icon = $(".trs_wrapper svg");
  var congrat_icon = $(".trs_wrapper .congrat-img");
  for (i = 0; i < thresholdMessage.length; i++) {
    progressBarWidth === 100 ? thresholdMessage[i].innerHTML = 'Congrats! You\'ve reached <strong>Free shipping!</strong>' : thresholdMessage[i].innerHTML = 'You\'re only <strong>$' + totalAway.toFixed('2') + '</strong> away from <strong>Free shipping!</strong>';
    if (progressBarWidth === 100) {
      if (congrat_icon.length && shipping_icon.length) {
        shipping_icon.hide();
        congrat_icon.show();
      }
    } else {
      if (congrat_icon.length && shipping_icon.length) {
        shipping_icon.show();
        congrat_icon.hide();
      }
    }
  }

  // Line item shipping amount
  var lineItemMsg = document.querySelectorAll('.cart__details-shipping');
  for (i = 0; i < lineItemMsg.length; i++) {
    progressBarWidth === 100 ? lineItemMsg[i].innerHTML = '<span class="text--bright-green"><strong>Free</strong></span>' : '';
  }
  },2000);
}
